import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../css/Header.css";
import htmlParser from 'html-react-parser'

export default function PavanSpeech({ links, pavanLink, sunwestLink}) {
  return (
    <Container>
      <Row>
        <Col className="pavanspeech">
          <p>
          {htmlParser(pavanLink)}, our CEO, spoke about how {htmlParser(sunwestLink)}'s exclusive{" "}
            <a href={links.mobileAppURL} target="_blank">
              {links.brandName}
            </a>{" "}
            and Instant Underwriting&trade; can help you save time and money, which you can instead use to double your business.
            <br />
            <br />
            We had a great turnout at our booth with people wanting to meet
            integral members of {htmlParser(sunwestLink)} and learn how our technology takes care
            of the clerical work (following up, condition reviews, DU/LP, and
            much more) so that they can spend their time marketing, sourcing,
            and harvesting new relationships.
          </p>
        </Col>
      </Row>
    </Container>
  );
}
